/*
  mapStyles.js - Google Maps styles per theme (TB-063, from the TB-064 maps).

  Google Maps cannot read CSS variables, so the dark palette is written out
  here once. The values mirror the dark --tb-* surface, border and muted text
  tokens. Light uses Google's default style.
*/

export const DARK_MAP_STYLES = Object.freeze([
  { elementType: 'geometry', stylers: [{ color: '#14232e' }] },
  { elementType: 'labels.text.fill', stylers: [{ color: '#9aa7b1' }] },
  { elementType: 'labels.text.stroke', stylers: [{ color: '#0e1a22' }] },
  { featureType: 'administrative', elementType: 'geometry.stroke', stylers: [{ color: '#26353f' }] },
  { featureType: 'poi', elementType: 'geometry', stylers: [{ color: '#1a2b37' }] },
  { featureType: 'poi.park', elementType: 'geometry', stylers: [{ color: '#12261f' }] },
  { featureType: 'road', elementType: 'geometry', stylers: [{ color: '#26353f' }] },
  { featureType: 'road', elementType: 'geometry.stroke', stylers: [{ color: '#1a2b37' }] },
  { featureType: 'road.highway', elementType: 'geometry', stylers: [{ color: '#38474f' }] },
  { featureType: 'transit', elementType: 'geometry', stylers: [{ color: '#1a2b37' }] },
  { featureType: 'water', elementType: 'geometry', stylers: [{ color: '#0e1a22' }] },
  { featureType: 'water', elementType: 'labels.text.fill', stylers: [{ color: '#6b7882' }] }
])

// Canvas colour shown before the tiles load, so a dark page does not flash
// Google's light grey. Light mirrors --tb-bg-muted, dark the map geometry.
export const MAP_BACKGROUND = Object.freeze({
  light: '#e8f0f6',
  dark: '#14232e'
})

// Pass resolvedTheme.value ('light' | 'dark'). Spread the result into the
// GMapMap options. backgroundColor only applies when the map is created; on a
// live theme change call applyMapBackground() as well.
export function mapStylesFor (theme) {
  const dark = theme === 'dark'
  return {
    styles: dark ? DARK_MAP_STYLES : [],
    backgroundColor: dark ? MAP_BACKGROUND.dark : MAP_BACKGROUND.light
  }
}

export function applyMapBackground (map, theme) {
  try {
    const div = map && map.getDiv && map.getDiv()
    if (div) div.style.backgroundColor = mapStylesFor(theme).backgroundColor
  } catch (e) { /* map not ready */ }
}
